export default "__VITE_ASSET__412646f9__"